import React, { useState } from 'react';
import { FaPaperPlane, FaPhone, FaEllipsisV } from 'react-icons/fa';

const Chat = ({ activeFriend }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  const sendMessage = () => {
    if (input.trim() !== '') {
      setMessages([...messages, { text: input, sender: 'You' }]);
      setInput('');
    }
  };

  return (
    <div className="w-3/4 flex flex-col bg-white h-full font-montserrat">
      <div className="p-4 bg-white border-b border-gray-200 flex items-center justify-between">
        <div className="flex items-center">
          {activeFriend && (
            <img
              src={activeFriend.image}
              alt={activeFriend.name}
              className="h-10 w-10 rounded-full mr-4"
            />
          )}
          <h2 className="text-2xl font-semibold text-[#AF9C80]">
            {activeFriend ? activeFriend.name : 'Select a friend to chat'}
          </h2>
        </div>
        {activeFriend && (
          <div className="flex items-center space-x-4">
            <FaPhone className="text-[#AF9C80] w-6 h-6 cursor-pointer hover:text-[#8e7a61]" />
            <FaEllipsisV className="text-[#AF9C80] w-6 h-6 cursor-pointer hover:text-[#8e7a61]" />
          </div>
        )}
      </div>
      <div className="flex-grow p-4 overflow-auto">
        <div className="flex flex-col space-y-4">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`flex ${
                message.sender === 'You' ? 'justify-end' : 'justify-start'
              }`}
            >
              <div
                className={`rounded-lg p-4 max-w-xs md:max-w-md ${
                  message.sender === 'You'
                    ? 'bg-[#AF9C80] text-white'
                    : 'bg-gray-200 text-black'
                }`}
              >
                <p>{message.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {activeFriend && (
        <div className="p-4 bg-white flex items-center border-t border-gray-200">
          <div className="relative flex-grow">
            <input
              className="w-full border border-gray-300 rounded-full p-2 pr-10 focus:outline-none focus:ring focus:ring-[#AF9C80]"
              type="text"
              value={input}
              placeholder="Type a message..."
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') sendMessage();
              }}
            />
            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#AF9C80] text-white rounded-full p-2 hover:bg-[#8e7a61] focus:outline-none focus:ring focus:ring-[#AF9C80]"
              onClick={sendMessage}
            >
              <FaPaperPlane className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chat;